module.exports = __webpack_public_path__ + "67e24c575ab0b533b1bbbf65d3494d50.png";